import adminApiClient from '@/services/admin/api.admin';
import ADMIN_API_ENDPOINTS from '@/services/admin/endpoints.admin';
async function list(params = {}) {
    const query = new URLSearchParams();
    if (params.limit != null)
        query.set('limit', String(params.limit));
    if (params.offset != null)
        query.set('offset', String(params.offset));
    if (params.type)
        query.set('type', params.type);
    const url = `${ADMIN_API_ENDPOINTS.LOCATIONS.BASE}${query.toString() ? `?${query.toString()}` : ''}`;
    return adminApiClient.get(url);
}
async function listByUser(userId, params = {}) {
    const query = new URLSearchParams();
    if (params.limit != null)
        query.set('limit', String(params.limit));
    if (params.offset != null)
        query.set('offset', String(params.offset));
    if (params.type)
        query.set('type', params.type);
    const url = `${ADMIN_API_ENDPOINTS.LOCATIONS.BY_USER(userId)}${query.toString() ? `?${query.toString()}` : ''}`;
    return adminApiClient.get(url);
}
async function remove(id) {
    const url = ADMIN_API_ENDPOINTS.LOCATIONS.BY_ID(id);
    return adminApiClient.delete(url);
}
async function get(id) {
    const url = ADMIN_API_ENDPOINTS.LOCATIONS.BY_ID(id);
    return adminApiClient.get(url);
}
async function create(body) {
    const url = ADMIN_API_ENDPOINTS.LOCATIONS.BASE;
    if (body instanceof FormData) {
        return adminApiClient.post(url, body);
    }
    // Envia JSON plano si es objeto
    return adminApiClient.post(url, body);
}
async function update(id, body) {
    const url = ADMIN_API_ENDPOINTS.LOCATIONS.BY_ID(id);
    if (body instanceof FormData) {
        return adminApiClient.post(url, body);
    }
    // Envia JSON plano si es objeto
    return adminApiClient.put(url, body);
}
// Imágenes globales de locaciones
async function listImages() {
    return adminApiClient.get(ADMIN_API_ENDPOINTS.LOCATION_IMAGES.BASE);
}
async function listImagesByUser(userId) {
    return adminApiClient.get(ADMIN_API_ENDPOINTS.LOCATION_IMAGES.BY_USER(userId));
}
async function deleteImage(id) {
    return adminApiClient.delete(ADMIN_API_ENDPOINTS.LOCATION_IMAGES.BY_ID(id));
}
async function setMainImage(id) {
    return adminApiClient.put(ADMIN_API_ENDPOINTS.LOCATION_IMAGES.SET_MAIN(id));
}
async function updateAlt(id, altText) {
    return adminApiClient.put(ADMIN_API_ENDPOINTS.LOCATION_IMAGES.BY_ID(id), { alt_text: altText });
}
async function createImage(formData) {
    return adminApiClient.post(ADMIN_API_ENDPOINTS.LOCATION_IMAGES.BASE, formData);
}
async function updateImage(id, formData) {
    return adminApiClient.post(ADMIN_API_ENDPOINTS.LOCATION_IMAGES.BY_ID(id), formData);
}
// Location Items
async function listItems() {
    return adminApiClient.get(ADMIN_API_ENDPOINTS.LOCATION_ITEMS.BASE);
}
async function listItemsByUser(userId) {
    return adminApiClient.get(ADMIN_API_ENDPOINTS.LOCATION_ITEMS.BY_USER(userId));
}
async function getItem(id) {
    return adminApiClient.get(ADMIN_API_ENDPOINTS.LOCATION_ITEMS.BY_ID(id));
}
async function createItem(body) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_ITEMS.BASE;
    if (body instanceof FormData) {
        return adminApiClient.post(url, body);
    }
    return adminApiClient.post(url, body);
}
async function updateItem(id, body) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_ITEMS.BY_ID(id);
    if (body instanceof FormData) {
        return adminApiClient.post(url, body);
    }
    return adminApiClient.post(url, body);
}
async function deleteItem(id) {
    return adminApiClient.delete(ADMIN_API_ENDPOINTS.LOCATION_ITEMS.BY_ID(id));
}
export default {
    list,
    listByUser,
    get,
    create,
    update,
    remove,
    // Imágenes:
    listImages,
    listImagesByUser,
    deleteImage,
    setMainImage,
    updateAlt,
    createImage,
    updateImage,
    // Items:
    listItems,
    listItemsByUser,
    getItem,
    createItem,
    updateItem,
    deleteItem,
};
